import { injectable } from 'inversify';

import { HttpService } from '@vk-hr-tek/core/http';
import { UnmarshallerService } from '@vk-hr-tek/core/unmarshaller';

import { UserRoleEnum } from '@app/types';
import { NavigationExternalItem } from '@app/router';
import { GetSideMenuResponse } from '@app/gen/side_menu';

@injectable()
export class LayoutService {
  constructor(
    private http: HttpService,
    private unmarshaller: UnmarshallerService,
  ) {}

  async getLogo() {
    const result = await this.http.getFile('/company/logo', {
      withSide: true,
    });

    return result;
  }

  async getCandidateLogo(candidateEventId: string) {
    const result = await this.http.getFile(
      '/candidate/company/logo',
      {
        withSide: true,
        withAuth: false,
      },
      { invite: candidateEventId },
    );

    return result;
  }

  async getAdditionalMenuItems(): Promise<
    Record<UserRoleEnum, NavigationExternalItem[]>
  > {
    return new Promise(() => {});
  }

  async getFastActions() {
    return [
      { label: 'Создать заявку', link: '/' },
      { label: 'Оформить отпуск', link: '/' },
      { label: 'Оформить командировку', link: '/' },
      { label: 'Запросить справку', link: '/' },
    ];
  }

  // в дальнейшем не понадобиться, так как для запроса для настроек и отображения будут использоваться разные ручки
  async getSideMenu() {
    const requestPath = '/side_menu';

    const result = await this.http.get(requestPath, {}, { withSide: false });

    const response = await this.unmarshaller.unmarshall(
      result,
      GetSideMenuResponse,
    );

    return response;
  }
}
